import styles from "./StockShowcase.module.css";
import Navbar from "../../components/Navbar/Navbar";
import { ScrollRestoration } from "react-router-dom";
import StockShowcaseComponent from "../../components/StockShowcaseComponent/StockShowcaseComponent";
import Slider from "../../components/Slider/Slider";
import Home from "../../images/StockDashboardHome.jpg";
import Funds from "../../images/StockDashboardFunds.jpg";
import Buy from "../../images/StockDashboardBuy.jpg";
import Sell from "../../images/StockDashboardSell.jpg";
import SkipLinks from "../../components/SkipLinks/SkipLinks";
const slides = [
	[
		Home,
		"Slide 1: Home Dashboard showing portfolio overview with stock performance chart and key metrics.",
	],
	[
		Funds,
		"Slide 2: Funds Page allowing users to add money to their account.",
	],
	[
		Buy,
		"Slide 3: Buy page where users can purchase stocks to add to their portfolio.",
	],
	[
		Sell,
		"Slide 4: Sell page where users can sell stocks from their portfolio.",
	],
];
export default function StockShowcase() {
	return (
		<>
			<SkipLinks />
			<ScrollRestoration />
			<Navbar />
			<div id="main-content" className={styles.container}>
				<Slider slides={slides} />
				<StockShowcaseComponent />
			</div>
		</>
	);
}
